import React, { useState } from 'react';
import { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import { publicAssets } from '@utils/url.utils';
import { Content, Label, Details, Image, Phone, Question, Wrapper } from './Support.elements';

export interface SupportProps {
    withoutMargin?: boolean;
    withoutBackground?: boolean;
}

const SupportTemplate: FC<SupportProps> = ({ withoutMargin, withoutBackground }) => {
    const { t } = useTranslations();

    return (
        <Wrapper withoutMargin={withoutMargin} withoutBackground={withoutBackground}>
            <Question>{t('cart.support.question')}</Question>
            <Content>
                <Image src={publicAssets('/team_person5_square.webp')} />
                <Details>
                    <Label>{t('cart.support.description')}</Label>
                    <Phone dangerouslySetInnerHTML={{ __html: t('cart.support.phone') }} />
                </Details>
            </Content>
        </Wrapper>
    );
};

export default SupportTemplate;
